import axios from 'api';
import Helpers, { T } from 'shared/helpers';
import db from 'database';
// Types
export const Types = {
  AUTHENTICATE_USER: 'user/AUTHENTICATE_USER',
  AUTHENTICATE_USER_SUCCESS: 'user/AUTHENTICATE_USER_SUCCESS',
  AUTHENTICATE_USER_FAILED: 'user/AUTHENTICATE_USER_FAILED',
  AUTHENTICATE_USER_ERROR_HANDLED: 'user/AUTHENTICATE_USER_ERROR_HANDLED',
  EXPIRE_USER: 'user/EXPIRE_USER',
  LOGOUT: 'user/LOGOUT',
  CLEAR_ERROR: 'user/CLEAR_ERROR',
};

/**
 * @type {{auth: {token: string, loading: boolean, error: string | null}, data: User}}
 */
const initialState = {
  auth: {
    token: localStorage.getItem('token'),
    loading: false,
    error: null,
  },
  data: JSON.parse(localStorage.getItem('udata')),
};

// Reducer function
export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case Types.AUTHENTICATE_USER:
      return {
        ...state,
        auth: {
          ...state.auth,
          loading: true,
          expired: false,
          error: undefined,
        },
      };
    case Types.AUTHENTICATE_USER_FAILED:
      return {
        ...state,
        auth: { ...state.auth, loading: false, error: action.payload.error },
      };
    case Types.AUTHENTICATE_USER_SUCCESS:
      return {
        ...state,
        auth: {
          ...state.auth,
          loading: false,
          token: action.payload.token,
        },
        data: {
          ...state.data,
          ...action.payload.user,
        },
      };
    case Types.AUTHENTICATE_USER_ERROR_HANDLED:
      return {
        ...state,
        auth: { ...state.auth, error: null },
      };
    case Types.LOGOUT:
      return {
        auth: {
          token: null,
          loading: false,
          error: null,
        },
        data: null,
      };
    case Types.EXPIRE_USER:
      return {
        ...state,
        auth: {
          token: null,
          loading: false,
          expired: true,
          error: 'O login expirou, por favor realize o login novamente.',
        },
        data: null,
      };
    case Types.CLEAR_ERROR:
      return { ...state, auth: { ...state.auth, error: null } };
    default:
      return state;
  }
}

// Action Creators
export const Creators = {
  authenticate: (email, password) => async (dispatch) => {
    try {
      dispatch({ type: Types.AUTHENTICATE_USER });
      const errors = [];
      if (T(email).length <= 0) {
        errors.push('O CAMPO EMAIL É REQUERIDO.');
      }
      if (T(password).length <= 0) {
        errors.push('O CAMPO PASSWORD É REQUERIDO.');
      }
      if (T(password).length < 8) {
        errors.push('A SENHA DEVE CONTER NO MÍNIMO 8 CARACTERES');
      }
      if (errors.length > 0) {
        throw new Error(errors.join(' '));
      }
      const url = '/login';
      try {
        const { data } = await axios.post(url, {
          email,
          password,
        });
        localStorage.setItem('token', `Bearer ${data.token}`);
        localStorage.setItem('udata', JSON.stringify(data.user));
        dispatch({
          type: Types.AUTHENTICATE_USER_SUCCESS,
          payload: { token: data.token, user: data.user },
        });
      } catch (woof) {
        throw new Error(Helpers.responseError(woof));
      }
    } catch (woof) {
      console.log(woof);
      dispatch({
        type: Types.AUTHENTICATE_USER_FAILED,
        payload: {
          error: woof.message,
        },
      });
    }
  },
  logout: () => async (dispatch) => {
    localStorage.clear();
    try {
      db.reset();
    } catch (oof) {
      window.location.reload();
    }
    dispatch({ type: Types.LOGOUT });
  },
  expire: () => async (dispatch) => {
    dispatch({ type: Types.EXPIRE_USER });
    localStorage.clear();
  },
  clear: () => async (dispatch) => {
    dispatch({ type: Types.CLEAR_ERROR });
  },
};
